export const appConfig = {
    GITHUB_REPOSITORY_NAME: 'TwitterClone',
};
